export function redirectToPayFast(
  redirectUrl: string,
  formData: Record<string, string>
) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = redirectUrl;

  for (const [name, value] of Object.entries(formData)) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
}
